// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { AppSettingsScopeTypes_abstract } from './../abstract/SagaBase/AppSettingsScopeTypes_abstract';
export class AppSettingsScopeTypes extends AppSettingsScopeTypes_abstract {}
